export const circles = [
    { id: 1, color: "lightgreen"},
    { id: 2, color: "pink"},
    { id: 3, color: "yellow"},
    { id: 4, color: "lightblue"},
  ];